import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { gitVersion } from '../git-version';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogConfigRUM } from './datadog.config';
import { datadogConfigLogger } from './datadog.config';


if (environment.production) {
  enableProdMode();
}

if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
  datadogRum.init(datadogConfigRUM);
  datadogRum.startSessionReplayRecording();

  datadogLogs.init(datadogConfigLogger);
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
    // eslint-disable-next-line no-console
      .catch(err => console.error(err));
  },
);
